import { getToday } from '@/common/functions/getToday';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRef, useState } from 'react';

const useSearchBox = ({ handleSearchCallback }) => {
	const today = getToday();
	const [selectedMarkets, setSelectedMarkets] = useState([]);
	const {
		options: { marketsOptions },
	} = useCommonDataContext();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const handleSearch = () => {
		const dateFrom = new Date(dateFromRef.current.value).toISOString();
		const dateTo = new Date(dateToRef.current.value).toISOString();
		const markets = selectedMarkets.map((market) => market.value);

		handleSearchCallback(dateFrom, dateTo, markets);
	};

	return {
		today,
		dateFromRef,
		dateToRef,
		handleSearch,
		selectedMarkets,
		marketsOptions,
		setSelectedMarkets,
	};
};

export default useSearchBox;
